import React, { Component } from "react";
import { connect } from "react-redux";
import Header from "../common/Header";
import Title from "../common/Title";
import ReadOnly from "../common/ReadOnly";
import Back from "../../assets/Back";
import { track } from "../../api/heap";
import * as actions from "../../state/actions/onboarding";
var autocomplete;
var parser = require("parse-address");

class EditOnboardingUserInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorAddress: null,
      autoCompletedAddressFormats: {
        street_number: "short_name",
        route: "long_name",
        locality: "long_name",
        administrative_area_level_1: "short_name",
        country: "long_name",
        postal_code: "short_name"
      },
      autoCompletedAddress: {
        street_number: "",
        route: "",
        locality: "",
        administrative_area_level_1: "",
        country: "",
        postal_code: ""
      },
      parsedAddress: {
        city: "",
        number: "",
        sec_unit_num: "",
        sec_unit_type: "",
        state: "",
        prefix: "",
        street: "",
        type: ""
      },
      formattedAddress: ""
    };
  }

  componentDidMount() {
    if (!window.onbeforeunload) {
      window.onbeforeunload = () => {
        return "Refreshing this page will cause you to lose your application progress. Continue?";
      };
    }

    // We might want to make sure our script is fully loaded
    this.initAutocomplete();

    const {
      shippingAddress: { street, city, state, zip } = {},
      shippingAddress: {
        normalizedAddress: { address_street: normalized_address } = {}
      } = {}
    } = this.props.user;
    if (street && city && state && zip) {
      this.setState({
        // formattedAddress: normalized_address || address
        formattedAddress: street
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    console.log("receiving props this one:", nextProps);

    const {
      shippingAddress: { street, city, state, zip } = {},
      shippingAddress: {
        normalizedAddress: { address_street: normalized_address } = {}
      } = {}
    } = nextProps.user;
    if (street && city && state && zip) {
      this.setState({
        // formattedAddress: normalized_address || address
        formattedAddress: street
      });
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  handlePrevious = () => {
    this.props.previousStep();
  };

  handleNext = () => {
    track("ONBOARDING_ADDRESS_STEP_CLICKED_CONTINUE");
    if (this.props.noValidate) {
      this.props.nextStep();
      return;
    }

    if (this.areFieldsValid()) {
      this.save();
    }

    if (this.props.pageComplete) this.props.nextStep();
  };

  areFieldsValid = () => {
    const {
      shippingAddress: { street, city, state, zip } = {}
    } = this.props.user;

    if (!street || !city || !state || !zip) {
      track("ONBOARDING_ERROR_ADDRESS_STEP", {
        message: "invalid_address"
      });
      this.setState({
        errorAddress: "A valid street, city, state, and zip are required"
      });
      return false;
    }

    this.setState({
      errorAddress: null,
      error: null
    });
    return true;
  };

  save = async () => {
    if (!this.areFieldsValid) {
      return false;
    }

    const {
      validateAddress,
      updateUserDatabase,
      nextStep,
      user: {
        email,
        shippingAddress: { street, city, state, zip, unitNumber }
      }
    } = this.props;

    // console.log("address is:", `${street} ${city} ${state} ${zip}`);
    // console.log(
    //   "Parsed address is:",
    //   `${pNumber} ${pPrefix} ${pStreet} ${pType}, ${sec_unit_type} ${sec_unit_num}, ${pCity}, ${pState}, ${pZip}`
    // );
    // const parsedUnit = ` ${sec_unit_type || "Unit"} ${sec_unit_num}`;

    validateAddress(
      {
        address: this.buildAddress()
      },
      { shipping: true, step: "editOnboardingUserInfo" },
      ({ valid, error, normalized_address }) => {
        if (!valid) {
          track("ONBOARDING_ERROR_EDITUSERINFO_STEP", {
            message: "unmailable_address"
          });
          this.setState({
            errorAddress:
              error || "Unmailable address - make sure to include unit numbers"
          });
          return;
        }

        updateUserDatabase(email, {
          shippingAddress: {
            street,
            city,
            state,
            zip,
            ...(unitNumber && { unitNumber }),
            normalized_address
          }
        });

        nextStep();
      }
    );
  };

  initAutocomplete = () => {
    // Create the autocomplete object, restricting the search predictions to
    // geographical location types.
    autocomplete = new window.google.maps.places.Autocomplete(
      document.getElementById("autocomplete"),
      { types: ["geocode"] }
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components.
    autocomplete.setFields(["address_component"]);

    // When the user selects an address from the drop-down, populate the
    // address fields in the form.
    autocomplete.addListener("place_changed", () => {
      console.log("Place changed!");
      this.fillInAddress();
      this.setState({ addressFilled: true });
    });
  };

  fillInAddress = () => {
    // Get the place details from the autocomplete object.
    const {
      parseAddress,
      props: { updateUser, user = {} }
    } = this;
    const { shippingAddress = {} } = user;

    var place = autocomplete.getPlace();
    if (!place.address_components) {
      // Address could not be parsed. Likely too short.
      return;
    }
    const { autoCompletedAddressFormats } = this.state;
    var n = {
      street_number: "",
      route: "",
      locality: "",
      administrative_area_level_1: "",
      country: "",
      postal_code: ""
    };

    for (var i = 0; i < place.address_components.length; i++) {
      var addressType = place.address_components[i].types[0];
      if (autoCompletedAddressFormats[addressType]) {
        var val =
          place.address_components[i][autoCompletedAddressFormats[addressType]];
        n[addressType] = val || "";
      }
    }

    const [street, city, state, zip] = [
      n.street_number && n.route ? `${n.street_number + " " + n.route}` : "",
      n.locality || "",
      n.administrative_area_level_1 || "",
      n.postal_code || ""
    ];

    this.setState({
      autoCompletedAddress: n,
      formattedAddress: street
    });
    updateUser({
      shippingAddress: { ...shippingAddress, street, city, state, zip }
    });
    parseAddress(`${street}, ${city}, ${state} ${zip}`);
  };

  buildAddress = () => {
    const payload = {};
    const { autoCompletedAddress, parsedAddress, formattedAddress } = this.state;
    const { street, unitNumber, city, state, zip } = this.props.user.shippingAddress || {};

    if (
      autoCompletedAddress.street_number &&
      autoCompletedAddress.route
    ) {
      console.log("We have autoCompletedAddress street and route");
      payload.address_street = `${autoCompletedAddress.street_number} ${autoCompletedAddress.route}`;
    } else {
      console.log(
        "We have no autoCompletedAddress street and route nor parsed number and street"
      );
      payload.address_street = street;
    }

    // Google Places doesn't do unit numbers. Add manually.
    const parsedPayload = this.parseAddress(payload.address_street, unitNumber);

    if (parsedPayload.sec_unit_num) {
      console.log("We already have unit information in the payload.");
      payload.address_street2 = `${parsedPayload.sec_unit_type || "Unit"} ${parsedPayload.sec_unit_num}`
    } else if (parsedPayload.sec_unit_type) {
      console.log(
        "We did not have unit information in the payload, but found data in parsedAddress. Adding unit information."
      );
      payload.address_street = `${payload.address_street} ${parsedPayload.sec_unit_type}`;
    } else if (unitNumber) {
      console.log(
        "Build: We have no parsed unit information in either the existing payload or the parsedAddress, but we do have unitNumber:",
        unitNumber
      );
      payload.address_street2 = `Unit ${unitNumber}`;
    }

    if (autoCompletedAddress.locality) {
      payload.address_city = autoCompletedAddress.locality;
    } else if (parsedAddress.city) {
      payload.address_city = parsedAddress.city;
    } else {
      payload.address_city = city;
    }

    if (autoCompletedAddress.administrative_area_level_1) {
      payload.address_subdivision =
        autoCompletedAddress.administrative_area_level_1;
    } else if (parsedAddress.state) {
      payload.address_subdivision = parsedAddress.state;
    } else {
      payload.address_subdivision = state;
    }

    payload.address_country_code = "US"; // always, for now

    if (autoCompletedAddress.postal_code) {
      payload.address_postal_code = autoCompletedAddress.postal_code;
    } else if (parsedAddress.zip) {
      payload.address_postal_code = parsedAddress.zip;
    } else {
      payload.address_postal_code = zip;
    }
    return payload;
  }

  parseAddress = (string, unitNumber) => {
    const parsed = parser.parseLocation(
      `${string}${unitNumber ? ` ${unitNumber}` : ""}`
    );
    if (!parsed) {
      return;
    }
    this.setState({
      parsedAddress: {
        ...parsed
      }
    });
    // console.dir(parsed)
    return parsed;
  };

  renderStateOptions = () => (
    <>
      <option value="" disabled selected hidden>
        State
      </option>
      <option value="AL">Alabama</option>
      <option value="AK">Alaska</option>
      <option value="AZ">Arizona</option>
      <option value="AR">Arkansas</option>
      <option value="CA">California</option>
      <option value="CO">Colorado</option>
      <option value="CT">Connecticut</option>
      <option value="DE">Delaware</option>
      <option value="DC">District Of Columbia</option>
      <option value="FL">Florida</option>
      <option value="GA">Georgia</option>
      <option value="HI">Hawaii</option>
      <option value="ID">Idaho</option>
      <option value="IL">Illinois</option>
      <option value="IN">Indiana</option>
      <option value="IA">Iowa</option>
      <option value="KS">Kansas</option>
      <option value="KY">Kentucky</option>
      <option value="LA">Louisiana</option>
      <option value="ME">Maine</option>
      <option value="MD">Maryland</option>
      <option value="MA">Massachusetts</option>
      <option value="MI">Michigan</option>
      <option value="MN">Minnesota</option>
      <option value="MS">Mississippi</option>
      <option value="MO">Missouri</option>
      <option value="MT">Montana</option>
      <option value="NE">Nebraska</option>
      <option value="NV">Nevada</option>
      <option value="NH">New Hampshire</option>
      <option value="NJ">New Jersey</option>
      <option value="NM">New Mexico</option>
      <option value="NY">New York</option>
      <option value="NC">North Carolina</option>
      <option value="ND">North Dakota</option>
      <option value="OH">Ohio</option>
      <option value="OK">Oklahoma</option>
      <option value="OR">Oregon</option>
      <option value="PA">Pennsylvania</option>
      <option value="RI">Rhode Island</option>
      <option value="SC">South Carolina</option>
      <option value="SD">South Dakota</option>
      <option value="TN">Tennessee</option>
      <option value="TX">Texas</option>
      <option value="UT">Utah</option>
      <option value="VT">Vermont</option>
      <option value="VA">Virginia</option>
      <option value="WA">Washington</option>
      <option value="WV">West Virginia</option>
      <option value="WI">Wisconsin</option>
      <option value="WY">Wyoming</option>
    </>
  );

  render() {
    const {
      user: { shippingAddress },
      user: { shippingAddress: { street, city, state, zip, unitNumber } = {} },
      user: {
        shippingAddress: {
          normalizedAddress: {
            address_street: normalized_address,
            address_city: normalized_city,
            address_subdivision: normalized_state,
            address_postal_code: normalized_zip
          } = {}
        } = {}
      },
      networkingError,
      updateUser,
      pageComplete,
      step: { error: stepError },
      previousStep
    } = this.props;
    const { handleNext, parseAddress, renderStateOptions } = this;
    const { error, errorAddress } = this.state;

    return (
      <div className="stepContainer">
        <Header />
        <div className="innerStepContainer">
          <div
            className="outerStack-mobile sm:outerStack"
            style={{ marginBottom: 88 }}
          >
            <div className="innerStack">
              <Title
                text={"Enter your shipping address"}
                disabled={pageComplete}
                disabledText={"Your address has been verified"}
              />
              <ReadOnly readOnly={pageComplete}>
                {errorAddress && (
                  <div className="errorText pt-3">{errorAddress}</div>
                )}
                <input
                  id="autocomplete"
                  value={this.state.formattedAddress}
                  placeholder="Address"
                  type="text"
                  className={`inputField inputFieldText ${errorAddress &&
                    "redBorder"}`}
                  onChange={({ target: { value: address } }) => {
                    if (!address) {
                      this.setState({ autoCompletedAddress: {} });
                    }
                    parseAddress(address);
                    this.setState({ formattedAddress: address });
                    updateUser({
                      shippingAddress: { ...shippingAddress, street: address }
                    });
                  }}
                  ref={ref => (this.addressInput = ref)}
                  disabled={pageComplete}
                />
                <input
                  type="text"
                  value={unitNumber}
                  placeholder="Apt/Suite/Unit # (if applicable)"
                  className={`inputField inputFieldText ${errorAddress &&
                    "redBorder"}`}
                  onChange={({ target: { value: unitNumber } }) => {
                    updateUser({
                      shippingAddress: { ...shippingAddress, unitNumber }
                    });
                  }}
                  disabled={pageComplete}
                />
                <input
                  type="text"
                  value={city}
                  placeholder="City"
                  className={`inputField inputFieldText ${errorAddress &&
                    "redBorder"}`}
                  onChange={({ target: { value: city } }) => {
                    updateUser({
                      shippingAddress: { ...shippingAddress, city }
                    });
                  }}
                  disabled={pageComplete}
                />
                <div className="flex">
                  <div className="flex-1">
                    <select
                      type="select"
                      value={state}
                      placeholder="State"
                      style={{
                        height: 50,
                        ...(!state ? { color: "gray" } : {})
                      }}
                      className={`inputField inputFieldText ${errorAddress &&
                        "redBorder"}`}
                      onChange={({ target: { value: state } }) => {
                        updateUser({
                          shippingAddress: { ...shippingAddress, state }
                        });
                      }}
                      disabled={pageComplete}
                    >
                      {renderStateOptions()}
                    </select>
                  </div>
                  <div className="flex-1 pl-4">
                    <input
                      type="text"
                      value={zip}
                      placeholder="Zip Code"
                      className={`inputField inputFieldText ${errorAddress &&
                        "redBorder"}`}
                      onChange={({ target: { value: zip } }) => {
                        updateUser({
                          shippingAddress: { ...shippingAddress, zip }
                        });
                      }}
                      disabled={pageComplete}
                    />
                  </div>
                </div>
                <div>
                  {error && (
                    <div
                      className="errorText"
                      style={{ position: "relative", top: 10 }}
                    >
                      {error}
                    </div>
                  )}
                  {networkingError && (
                    <div
                      className="errorText"
                      style={{ position: "relative", top: 10 }}
                    >
                      Error saving your data
                    </div>
                  )}
                  {stepError && (
                    <div
                      className="errorText"
                      style={{ position: "relative", top: 10 }}
                    >
                      {stepError}
                    </div>
                  )}
                </div>
              </ReadOnly>
              <input
                type="button"
                name="button"
                value="Continue"
                className={`continueButton cursor-pointer`}
                onClick={handleNext}
              />
            </div>
          </div>
        </div>
        <div className="bottomBar md:absolute inset-x-0 bottom-0">
          <div className="bottomBarText-mobile sm:bottomBarText hidden">
            <div
              onClick={() => {
                previousStep();
              }}
            >
              <Back className="backButtonIcon" />
              <input
                type="button"
                name="button"
                value="Back"
                className="backButton"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    user: state.register.user,
    step: state.register.editOnboardingUserInfo,
    networkingError: state.register.networkingError
  }),
  actions
)(EditOnboardingUserInfo);
